import globalAxios from "../../../util/Api";
import { GET_MONTH_PLANS, GET_USER_DATA, START_LOADING, GET_MONTH_PLANS_PDF, STOP_LOADING, ERROR, GET_MONTH_PLANS_SHEET} from "./types";
import { LogoutAction } from "../../../actions";

export const GetMonthPlans = (report_type) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/six_month_plan`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_MONTH_PLANS, payload: res.data })
          dispatch({ type: GET_USER_DATA, payload: res.data.user_date })
          dispatch(GetMonthPlansPDF("dayssold"))
            dispatch(GetMonthPlanSheet(report_type))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetMonthPlansPDF = (days_sold_assigned) => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/reports/six_month_plan_pdf?days_sold_assigned=${days_sold_assigned}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_MONTH_PLANS_PDF, payload: href })
        }
      })
  }
}

export const GetMonthPlanSheet = (days_sold_assigned) => {
    return (dispatch) => {
        dispatch({ type: GET_MONTH_PLANS_SHEET })
        globalAxios().get(`/api/v1/reports/six_month_plan_sheet?days_sold_assigned=${days_sold_assigned}`)
            .then(({ data }) => {
                const binaryString = atob(data);
                const len = binaryString.length;
                const buffer = new ArrayBuffer(len);
                const view = new Uint8Array(buffer);
                for (let i = 0; i < len; i += 1) {
                    view[i] = binaryString.charCodeAt(i);
                }
                const blob = new File([view], { type: 'application/vnd-xls' });
                const excel_href = window.URL.createObjectURL(blob);
                if (data) {
                    dispatch({ type: GET_MONTH_PLANS_SHEET, payload: excel_href })
                }

            }).catch(err => {
            dispatch({ type: STOP_LOADING })
            if (err.response)
                if (err.response.status === 401) {
                    dispatch(LogoutAction())
                }
        })
    }
}